document.addEventListener("DOMContentLoaded", function () {
  const deliveryMessage = document.getElementById("delivery-message");

  function updateDeliveryMessage(variant) {
    if (!variant || !deliveryMessage) return;

    if (variant.inventory_quantity <= 0) {
      deliveryMessage.style.display = "block";
    } else {
      deliveryMessage.style.display = "none";
    }
  }

  document.addEventListener("variant:change", function (event) {
    const variant = event.detail.variant;
    updateDeliveryMessage(variant);
  });

  // Verifica en carga inicial por si ya hay una variante seleccionada
  if (window.Product && Product.variants && Product.variants.length > 0) {
    const currentVariantId = document.querySelector('[name="id"]')?.value;
    const currentVariant = Product.variants.find(v => v.id == currentVariantId);
    updateDeliveryMessage(currentVariant);
  }
});
